import { render, staticRenderFns } from "./UniversitiesList.vue?vue&type=template&id=dc5d4738&"
import script from "./UniversitiesList.vue?vue&type=script&lang=js&"
export * from "./UniversitiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports